import app from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'

const config = {
    apiKey: "AIzaSyBjqMGP5PECngYKh87nE2II9pyNEnmAXXI",
    authDomain: "semana-meio-ambiente.firebaseapp.com",
    databaseURL: "https://semana-meio-ambiente.firebaseio.com",
    projectId: "semana-meio-ambiente",
    storageBucket: "semana-meio-ambiente.appspot.com",
    messagingSenderId: "424356012876",
    appId: "1:424356012876:web:655dc33af7b3a733a3e5e9"
}

const defaultApp = app.initializeApp(config)

export const firestore = defaultApp.firestore()
export const storage = defaultApp.storage()
export const auth = defaultApp.auth()